var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18340",
    transform: "translate(-1452 -479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5373",
    d: "M0 0H13V2H0z",
    className: "cls-1",
    transform: "translate(1456 479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5376",
    d: "M0 0H2V2H0z",
    className: "cls-1",
    transform: "translate(1452 479)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5374",
    d: "M0 0H13V2H0z",
    className: "cls-1",
    transform: "translate(1456 485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5377",
    d: "M0 0H2V2H0z",
    className: "cls-1",
    transform: "translate(1452 485)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5375",
    d: "M0 0H13V2H0z",
    className: "cls-1",
    transform: "translate(1456 491)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5378",
    d: "M0 0H2V2H0z",
    className: "cls-1",
    transform: "translate(1452 491)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.921142cc.svg";
export { ForwardRef as ReactComponent };